module.exports = __webpack_public_path__ + "img/profile-bg.4ad05be0.png";